function injectCSSIntoShadowRoot(elementId, cssString) {
  const targetElement = document.getElementById(elementId);
  
  if (!targetElement) {
    return false;
  }

  let shadowRoot = targetElement.shadowRoot;
  
  if (!shadowRoot) {
    shadowRoot = targetElement.attachShadow({ mode: 'open' });
  }

  const existingStyle = shadowRoot.querySelector('style');
  
  if (existingStyle) {
    existingStyle.textContent += '\n' + cssString;
  } else {
    const styleElement = document.createElement('style');
    styleElement.textContent = cssString;
    shadowRoot.appendChild(styleElement);
  }
  
  return true;
}

function injectCSSIntoAppEmbed(cssString) {
  const defaultCSS = `
   
  `;
  
  const combinedCSS = defaultCSS + cssString;
  return injectCSSIntoShadowRoot('app-embed', combinedCSS);
}

function waitForElementAndInjectCSS(elementId, cssString, maxAttempts = 50) {
  let attempts = 0;
  
  const checkElement = () => {
    attempts++;
    const element = document.getElementById(elementId);
    
    if (element) {
      return injectCSSIntoShadowRoot(elementId, cssString);
    } else if (attempts < maxAttempts) {
      setTimeout(checkElement, 100);
    } else {
      return false;
    }
  };
  
  checkElement();
}

function waitForAppEmbedAndInjectCSS(cssString) {
  const defaultCSS = `
    div#form-container-ref section[class^="_formContainer_"] {
      padding: 2.4rem;
      background: white;
      border-radius: 1.2rem;
      width: unset;
    }
    
    button[class*="_formSubmitButton_"] {
      color: rgb(var(--color-button-border))!important;
      border: 0.1rem solid var(--color-button-border)!important;
      border-radius: var(--buttons-radius-outset)!important;
      background: transparent!important;
    }
    button[class*="_formSubmitButton_"]:hover {
      background-color: var(--color-button-hover)!important;
      color: var(--color-button-text-hover)!important;
      filter: none!important;
    }
  
    form div[class^="_formFieldContainer_"]:focus-within label[class^="_formInputFieldLabel_"] {
      transform: none;
    }

    form div[class^="_formFieldContainer_"] label {
      position: unset;
      margin-bottom: 0.8rem;
      color: var(--color-text);
    }

    form div[class^="_formFieldContainer_"] {
      display: flex;
      flex-direction: column-reverse;
    }
    form div[class^="_formFieldContainer_"]::before, form div[class^="_formFieldContainer_"] textarea {
      background: transparent;
    }
    form div[class^="_formFieldContainer_"] input, form div[class^="_selectContainer_"] button  {
      background-color: transparent;
      padding-top: 15px;
      padding-bottom: 15px;
    }
    form div[class^="_formPhoneInputContainer_"] div.phone-country-selector  {
       align-content: flex-end;
    }
    form div[class^="_formPhoneInputContainer_"] label[class^="_formInputFieldLabel_"]  {
       transform: none;
    }
  `;
  
  const combinedCSS = defaultCSS + cssString;
  return waitForElementAndInjectCSS('app-embed', combinedCSS);
}

function autoInjectOnLoad() {
  setTimeout(() => {
    waitForAppEmbedAndInjectCSS('');
  }, 1000);
}

document.addEventListener('DOMContentLoaded', autoInjectOnLoad);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoInjectOnLoad);
} else {
  autoInjectOnLoad();
}

window.injectCSSIntoShadowRoot = injectCSSIntoShadowRoot;
window.injectCSSIntoAppEmbed = injectCSSIntoAppEmbed;
window.waitForElementAndInjectCSS = waitForElementAndInjectCSS;
window.waitForAppEmbedAndInjectCSS = waitForAppEmbedAndInjectCSS;
